<template>
  <div class="col-xs-6 col-md-4">
    <article class="product">
      <a itemprop="url" :href="productUrl">
        <div class="product-image">
          <img :alt="name" :src="image" height="240px" width="240px" />
          <div class="product-links">
            <span class="btn btn-primary sole-btn">Shop Now</span>
          </div>
        </div>
      </a>
      <h6 class="product-title" itemprop="name">
        <a :href="productUrl">{{ name }}</a>
      </h6>
      <span itemprop="price"><p class="product-price">{{ priceRange }}</p></span>
      <div class="product-ratings">
        <div class="star-container star-float-left">
          <span :class="starRatingCssClass" />
          <span :class="starRemainderCssClass" />
        </div>
        <span :class="soyPerformanceCssClass" />
      </div>
    </article>
  </div>
</template>

<script>
  export default {
    props: {
      fragrance: { required: true, type: Object }
    },
    computed: {
      name() {
        return this.fragrance.name;
      },
      image() {
        return this.fragrance.image;
      },
      productUrl() {
        return `/${this.fragrance.custom_url}`;
      },
      starRating() {
        const rawRating = this.fragrance.rating;
        return Number.isNaN(rawRating) ? 0 : Math.round(rawRating);
      },
      starRatingCssClass() {
        return `star-rating star-rating-${this.starRating}`;
      },
      starRemainderCssClass() {
        return `remainder-stars remainder-of-${this.starRating}`;
      },
      soyPerformanceCssClass() {
        return `soy-performance soy-performance-${this.fragrance.soy_performance}`;
      },
      priceRange() {
        const minPrice = this.fragrance.min_price;
        const maxPrice = this.fragrance.max_price;
        if (minPrice === maxPrice) {
          return `$${minPrice}`
        }
        return `$${minPrice} - $${maxPrice}`;
      }
    }
  }
</script>
